import { format, isDate, isValid } from 'date-fns';
import React, { ReactNode } from 'react';
import { FormQuestionType } from 'shared/types/forms';
import { setTimeValueFromString } from 'shared/utils/setTimeValueFromString';
import styled from 'styled-components/macro';
import { FormAnswer } from './FormAnswer';
import { RequestFormInput } from './types';

const Time = styled.div`
  text-transform: lowercase;
`;

const StyledList = styled.ul`
  margin-left: 16px;
`;

export const renderFormAnswer = ({ type, answer }: RequestFormInput): ReactNode => {
  if (!answer) return '';
  switch (type) {
    case FormQuestionType.checkbox:
      return Boolean(answer) ? 'Yes' : 'No';
    case FormQuestionType.multipleSelection:
      if (Array.isArray(answer)) {
        return (
          <StyledList>
            {answer.map((value) => {
              return <li key={value}>{value}</li>;
            })}
          </StyledList>
        );
      }
      return (
        <StyledList>
          {(answer as string).split(',').map((value) => (
            <li key={value}>{value}</li>
          ))}
        </StyledList>
      );
    case FormQuestionType.dateInput:
      const [year, month, day] = (answer as string).split('-').map((string) => Number(string));

      const date = new Date();
      date.setFullYear(year);
      date.setMonth(month - 1);
      date.setDate(day);
      date.setHours(0, 0, 0, 0);

      if (!isDate(date) || !isValid(date)) return '';

      return format(date || '', "cccc',' PP");
    case FormQuestionType.timeInput:
      const timeDate = setTimeValueFromString(new Date(), answer as string);
      if (!isDate(timeDate) || !isValid(timeDate)) return '';
      return <Time>{format(timeDate || '', 'h:mma')}</Time>;
    case FormQuestionType.signatureInput:
      return `Signed? ${answer ? 'Yes' : 'No'}`;
    default:
      return answer;
  }
};
type FormAnswerWithContentProps = {
  small?: boolean;
  question: RequestFormInput;
};

export const FormAnswerWithContent = ({ small, question }: FormAnswerWithContentProps): JSX.Element => {
  return (
    <FormAnswer question={question.prompt} small={small}>
      {renderFormAnswer(question) || '(No answer provided)'}
    </FormAnswer>
  );
};
